import { render, staticRenderFns } from "./BrandTutorialVideoItem.vue?vue&type=template&id=09a33db1&scoped=true&"
import script from "./BrandTutorialVideoItem.vue?vue&type=script&lang=ts&"
export * from "./BrandTutorialVideoItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTutorialVideoItem.vue?vue&type=style&index=0&id=09a33db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a33db1",
  null
  
)

export default component.exports